import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import siva from "../assets/siva.png";
import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const contactDetails = [
  {
    title: "Our Location",
    desc: "Telangana | Andhra Pradesh | Bengaluru | USA",
    icon: <LocationOnIcon sx={{ fontSize: 40, mb: 1 }} />,
  },
  {
    title: "Phone Number",
    desc: "+91 9121711234",
    icon: <PhoneIcon sx={{ fontSize: 40, mb: 1 }} />,
  },
  {
    title: "Email Address",
    desc: "info@pujaservices.com",
    icon: <EmailIcon sx={{ fontSize: 40, mb: 1 }} />,
  },
];

const ContactUs = () => {
  return (
    <>
      <Header />
      <Grid container spacing={5} sx={{ p: { xs: 2, md: 6 }, mt: 10 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: { xs: 0, md: 15 },
            width: "100%",
            mb: 4,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 16, md: 22 },
                color: "#6d1675",
              }}
            >
              Contact Us
            </Typography>
            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
                mx: "auto",
              }}
            />
          </Box>
        </Box>

        {contactDetails.map((contact, index) => (
          <Grid size={{ xs: 12, md: 4 }} key={index}>
            <Card
              sx={{
                p: 2,
                height: 220,
                borderRadius: 3,
                bgcolor: "#6d1675",
                color: "#fff",
                ":hover": { bgcolor: "#ffc20f" },
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  px: 2,
                  py: 4, // adjusted padding
                }}
              >
                {contact.icon}
                <Typography sx={{ fontSize: 20, fontWeight: "bold", mt: 2 }}>
                  {contact.title}
                </Typography>
                <Typography sx={{ mt: 1, textAlign: "center" }}>
                  {contact.desc}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Grid container sx={{ justifyContent: "center", p: { xs: 0, md: 6 } }}>
        <Grid size={{ xs: 10, md: 10 }}>
          <Card
            elevation={6}
            sx={{
              borderRadius: 3,
            }}
          >
            <CardContent>
              <Grid container spacing={3} alignItems="stretch">
                {/* Left: Form */}
                <Grid size={{ xs: 12, md: 7 }} sx={{ p: { xs: 0, md: 2 } }}>
                  <TextField
                    fullWidth
                    label="Name"
                    variant="outlined"
                    margin="normal"
                  />
                  <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    variant="outlined"
                    margin="normal"
                  />
                  <TextField
                    fullWidth
                    label="Phone"
                    type="tel"
                    variant="outlined"
                    margin="normal"
                  />
                  <TextField
                    fullWidth
                    label="Your Message"
                    multiline
                    rows={4}
                    variant="outlined"
                    margin="normal"
                  />
                  <Box textAlign="left" mt={2}>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#ffc20f",
                        color: "#fff",
                        fontWeight: "bold",
                        px: 4,
                        py: 1,
                        borderRadius: 2,
                        boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                        "&:hover": { bgcolor: "#b91c1c" },
                      }}
                    >
                      Send Now
                    </Button>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 5 }}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={siva}
                      alt="Shiva"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "12px",
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Footer />
    </>
  );
};

export default ContactUs;

